export default __webpack_public_path__ + "13aa8f7a603a9832a28c32a20c84b3b0.png";